var React = require('react');

function IconDownloadInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.95 17.186v1.126H.563v-1.126H14.95zM8.321.563v12.294l4.152-4.134.794.8-5.541 5.522L1.43 9.55l.731-.857 5.033 4.301L7.195.563h1.126z"}));
}

IconDownloadInline.defaultProps = {"width":"15","height":"19","viewBox":"0 0 15 19"};

module.exports = IconDownloadInline;

IconDownloadInline.default = IconDownloadInline;
